import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    root: {
      borderTop: "".concat(componentTheme.rootBorderWidth, " solid ").concat(componentTheme.rootBorderColor),
      margin: "0 ".concat(componentTheme.rootMargin),
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    editFeedback: {
      margin: "0 ".concat(componentTheme.editFeedbackMargin)
    },
    editFeedbackButtons: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    points: {
      width: componentTheme.pointsWidth,
      padding: componentTheme.pointsPadding,
      margin: componentTheme.pointsMargin
    },
    pointsSection: {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: "0 ".concat(componentTheme.pointsSectionPadding)
    },
    regradeParent: {
      display: 'flex',
      alignItems: 'center'
    },
    originalScore: {
      display: 'flex',
      alignItems: 'center'
    },
    regradetext: {
      display: 'flex',
      alignItems: 'center'
    },
    divider: {
      margin: componentTheme.dividerMargin
    },
    defaultNumberInput: {
      display: 'flex',
      alignItems: 'center'
    },
    pointsPossible: {
      marginLeft: componentTheme.pointsPossibleMargin
    },
    subjectiveButtonsWrapper: _defineProperty({}, mp, {
      display: 'none'
    }),
    feedbackButtonWrapper: _defineProperty({}, mp, {
      display: 'none'
    }),
    regradeButtonWrapper: _defineProperty({}, mp, {
      display: 'none'
    })
  };
};
export default generateStyle;